import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./header.css";

const navItems = [
  {
    label: "Home",
    to: "/",
  },
  {
    label: "About FRT",
    to: "/about",
    children: [
      {
        label: "About Us",
        to: "/about",
        children: [
          { label: "What Are We?", to: "/about" },
          { label: "Our History", to: "/historytimeline" },
          { label: "Our Mission and Vision", to: "/mission" },
        ],
      },
      {
        label: "Our Team",
        to: "/",
        children: [
          { label: "The Executive Team", to: "/executive" },
          { label: "Board of Trustees", to: "/trustee" },
          { label: "Our Staff", to: "/staff" },
        ],
      },
      { label: "Projects", to: "/projects" },
      // { label: "Feedback", to: "/" },
      // { label: "Strategic Direction", to: "/" },
      {
        label: "Policy",
        to: "/",
        children: [
          // { label: "Privacy Policy", to: "/" },
          { label: "Mlimi App Policy", to: "/policy/mlimi-app-polocy" },
        ],
      },
    ],
  },
  {
    label: "News & Media",
    to: "/",
    children: [
      { label: "Latest News", to: "/publications" },
      { label: "Publications", to: "/publications" },
      // { label: "Events", to: "/" },
    ],
  },
  {
    label: "Our Works",
    to: "/services",
    children: [
      { label: "Work With Us", to: "/services" },
    ],
  },
  {
    label: "Services",
    to: "/services",
    children: [
      { label: "What We Do", to: "/services" },
      // { label: "Weather Updates", to: "/" },
      // {
      //   label: "Farmers’ Hub",
      //   to: "/",
      //   children: [],
      // },
      { label: "Opportunities and Careers", to: "/careers" },
    ],
  },
  {
    label: "Projects",
    to: "/current-projects",
    children: [
      { label: "Current Projects", to: "/current-projects" },
      { label: "All Projects", to: "/projects" },
    ],
  },
  {
    label: "Contact",
    to: "/contact",
  },
];

function MobileNavItem({ item, depth = 0, openMenus, toggleMenu }) {
  const hasChildren = item.children && item.children.length > 0;
  const isOpen = openMenus[item.label];

  return (
    <li className={`mobile-nav-item depth-${depth}`}>
      <div className="mobile-nav-link-row">
        {hasChildren ? (
          <button
            type="button"
            className="mobile-nav-link"
            onClick={() => toggleMenu(item.label)}
            aria-expanded={isOpen}
          >
            {item.label}
            <span className={`submenu-arrow ${isOpen ? "open" : ""}`}>▸</span>
          </button>
        ) : (
          <Link className="mobile-nav-link" to={item.to} onClick={() => toggleMenu(null)}>
            {item.label}
          </Link>
        )}
      </div>
      {hasChildren && isOpen && (
        <ul className="mobile-submenu">
          {item.children.map((child) => (
            <MobileNavItem
              key={child.label}
              item={child}
              depth={depth + 1}
              openMenus={openMenus}
              toggleMenu={toggleMenu}
            />
          ))}
        </ul>
      )}
    </li>
  );
}

const Header = () => {
  const [navList, setNavList] = useState(false); // mobile nav open/close
  const [openMenus, setOpenMenus] = useState({}); // which submenus are open

  // Toggle submenu open/close by label
  const toggleMenu = (label) => {
    if (!label) {
      setNavList(false);
      setOpenMenus({});
      return;
    }
    setOpenMenus((prev) => ({
      ...prev,
      [label]: !prev[label],
    }));
  };

  return (
    <header>
      <div className="container flex header-container">
        <div className="logo">
          <Link to="/">
            <img src={'/images/logo.png'} alt="Logo" />
          </Link>
        </div>
        {/* Desktop Nav */}
        <nav className="nav desktop-nav">
          <ul className="flex">
            {navItems.map((item) => (
              <li key={item.label} className={item.children ? "dropdown" : ""}>
                <Link to={item.to}>{item.label} {item.children && <i className="bi bi-chevron-down"></i>}</Link>
                {item.children && (
                  <ul>
                    {item.children.map((child) => (
                      <li key={child.label} className={child.children ? "dropdown" : ""}>
                        <Link to={child.to}>{child.label} {child.children && <i className="bi bi-chevron-right"></i>}</Link>
                        {child.children && (
                          <ul>
                            {child.children.map((sub) => (
                              <li key={sub.label}>
                                <Link to={sub.to}>{sub.label}</Link>
                              </li>
                            ))}
                          </ul>
                        )}
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            ))}
          </ul>
        </nav>
        {/* Mobile Nav */}
        <nav className={`mobile-nav${navList ? " open" : ""}`}>
          <ul>
            {navItems.map((item) => (
              <MobileNavItem
                key={item.label}
                item={item}
                openMenus={openMenus}
                toggleMenu={toggleMenu}
              />
            ))}
          </ul>
        </nav>
        {/* Social Icons */}
        <form className="flex social-form">
          <div className="social">
            <a href="https://web.facebook.com/FarmRadioMw" rel="noopener" target="_blank">
              <img src="/images/facebook.png" alt="Facebook" />
            </a>
          </div>
          <div className="social">
            <a href="https://www.youtube.com/@farmradiotrust846" rel="noopener" target="_blank">
              <img src="/images/youtube.png" alt="YouTube" />
            </a>
          </div>
          <div className="social">
            <a href="https://twitter.com/FarmRadioMw" rel="noopener" target="_blank">
              <img src="/images/twitter.png" alt="Twitter" />
            </a>
          </div>
        </form>
        {/* Hamburger */}
        <div className="toggle mobile-nav-toggle">
          <button
            aria-label="Toggle navigation"
            onClick={() => {
              setNavList((v) => !v);
              setOpenMenus({});
            }}
          >
            {navList ? <i className="fa fa-times"></i> : <i className="fa fa-bars"></i>}
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
